import { createSlotRecipe } from './runtime';

const datePickerConfig = {"name":"datePicker","slots":["root","label","clearTrigger","content","control","input","monthSelect","nextTrigger","positioner","prevTrigger","rangeText","table","tableBody","tableCell","tableCellTrigger","tableHead","tableHeader","tableRow","trigger","viewTrigger","viewControl","yearSelect","presetTrigger","view"]}

export const datePicker = /* @__PURE__ */ createSlotRecipe(datePickerConfig)